import React, { useState, useEffect } from 'react';
import {app} from './firebaseconfig'
import {useForm} from 'react-hook-form'
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import Header1 from "./Header"
import Footer from "./Footer"

function ContactForm() {
    const{register, handleSubmit, errors} = useForm()
    const db = app.firestore()

   


  const onSubmit = async (data) => {
   
    db.collection("ContactUsForm").doc().set({
      Name: data.Name,
      Message: data.Message,
      Email: data.Email,
      Handled: false,
    })
    alert("submitted")
    }
//{app.auth().currentUser ? (<button> Submit </button> ) : (<Link to="/Login"> Login</Link>)}
   return (
     <>
           <section id="cta2" className="container">
      <Header1></Header1>
      </section>
      <br></br>
      <br></br>
      <br></br>
      <section className="box special">
          <h2>Contact Us</h2>
          <br/>
       <form onSubmit={handleSubmit(onSubmit)}>
 
       <input type="text" placeholder="Name" name="Name" ref={register({required: true})}/> 
         {errors.Name && <div>{"This is required"}</div>}<br></br>

         <input type="text" placeholder="Email" name="Email" ref={register({required: true})}/> 
         {errors.Email && <div>{"This is required"}</div>}<br></br>
         
         <textarea type="text" placeholder="Message" name="Message" ref={register({required: true})}/> 
         {errors.Message && <div>{"this is required"}</div>}<div></div><br></br>
        
         <button className="button primary"> Submit </button>
     </form>
     </section>
     <Footer></Footer>
     </>
   );

}

export default ContactForm;